import Email from '../../models/Email';
export const linkUrls = {
  video: 'https://prezi.com/v/view/ndhwa_V1d30',
  design: 'https://prezi.com/i/view/dhwa_D3s1gn',
  present: 'https://prezi.com/p/view/hwa_Pr3s3nt'
};
export const linkUrl = linkUrls.video;
export const fn = () => {};
export const unlistedLinkData = {
  link_id: 'string',
  prezi_oid: 'string',
  url: linkUrl
};
export const documentAccessOptions = [{
  label: 'owner',
  value: 'owner'
}, {
  label: 'can present',
  value: 'can_present'
}, {
  label: 'can comment',
  value: 'can_comment'
}, {
  label: 'can edit',
  value: 'can_edit'
}, {
  label: 'can view',
  value: 'can_view'
}, {
  label: 'no access',
  value: 'no_access'
}];
export const email = Email.unsafeFromString('bobby.marley@nocry.com');